/**
 * Common reducer flags
 *
 */
export enum ReducerFlag {
  INIT = "",
  SUCCESS = "success",
  FAILED = "failed",
}
